import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import Slide from "./Slide";

// style rules
import { Sizes } from "../../styles";

const FeaturedSlider = ({ slidesJson }) => {
	const [slides] = useState(JSON.parse(slidesJson));
	const [length] = useState(slides.length);
	const [currentIndex, setCurrentIndex] = useState(0);

	const toggleNexSlide = () => {
		if (currentIndex < length - 1) {
			return setCurrentIndex((prevState) => prevState + 1);
		}
	};

	const togglePrevSlide = () => {
		if (currentIndex > 0) {
			return setCurrentIndex((prevState) => prevState - 1);
		}
	};

	if (!slides) return null;

	return (
		<Slider>
			<Slide
				togglePrevSlide={togglePrevSlide}
				toggleNexSlide={toggleNexSlide}
				slide={slides[currentIndex]}
				currentIndex={currentIndex}
				length={length}
			/>
		</Slider>
	);
};

FeaturedSlider.propTypes = {
	slidesJson: PropTypes.string,
};

export default FeaturedSlider;

const Slider = styled.div`
	padding-top: 4rem;
	display: grid;
	grid-template-columns: 1fr;

	@media only screen and (min-width: ${Sizes.screens.exhibitBreakpoint}) {
		padding-top: 9.5rem;
		grid-template-columns: 736px 1fr;
		gap: 6rem;
	}
`;